import { useEffect } from 'react';

const utils = {};

// eslint-disable-next-line consistent-return
utils.closeChatBotWindow = () => {
  window.parent.postMessage(
    { type: 'CLOSE_CHATBOT', open: false },
    window.location.origin
  );
};

utils.useChatbotClose = () => {
  useEffect(() => {
    const handleClick = (event) => {
      utils.closeChatBotWindow(event);
    };
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
};

export default utils;
